import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { AuthUserController } from 'infraestructure/controllers/authUserController'
import { FirstChangePasswordRepresentativeCommandRequest } from 'domain/entities/authUser'
import { Status } from 'domain/models/apiResponse'
import {
  authUserState,
  firstChangePassError,
  firstChangePassStart,
  firstChangePassSuccess,
} from 'presentation/redux/slices/authUserSlice'
import { urlRoutes } from 'presentation/routes/config/urlRoutes/urlRoutes'
import useError from 'presentation/hooks/useError'

export const useFirstChange = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { isLoading, error } = useSelector(authUserState)
  const { getErrorMessage } = useError()

  const firstChange = async (data: FirstChangePasswordRepresentativeCommandRequest) => {
    dispatch(firstChangePassStart())
    try {
      const response = await AuthUserController.firstChangePass(data)
      if (response?.status === Status.success) {
        dispatch(firstChangePassSuccess())
        navigate(urlRoutes.private.goalAssignment.urlTo)
        return true
      }
    } catch (err) {
      dispatch(firstChangePassError(getErrorMessage({ error: err })))
    }
  }
  return { firstChange, isLoading, error }
}
